export const BASE_URL = "https://konkurs.ingorod24.ru/api/v1/contests/";
export const NEWS_API = "https://ingorod24.ru/api/v1/news/?contest=";
